import React, { useState } from 'react';
import SEO from '../components/SEO';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  // SEO structured data
  const seoStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'name': 'Frequently Asked Questions',
    'description': 'Common questions about Pharmaceutical Database'
  };

  const faqs = [
    {
      question: 'What is Pharmaceutical Database?',
      answer: 'Pharmaceutical Database is a comprehensive platform that integrates data from 8 major pharmaceutical and medical databases (FDA Drugs, Clinical Trials, ChEMBL, Orange Book, ChEBI, PubChem, RxNorm, and DailyMed) to provide healthcare professionals, researchers, and patients with free access to pharmaceutical information.'
    },
    {
      question: 'Is this service free?',
      answer: 'Yes! Pharmaceutical Database is completely free to use. All our data comes from public government sources and is made available to you at no cost.'
    },
    {
      question: 'Can I use this information for medical decisions?',
      answer: 'While our database provides accurate information from authoritative sources, we recommend consulting with healthcare professionals before making any medical decisions. This tool is designed for informational and research purposes.'
    },
    {
      question: 'How often is the data updated?',
      answer: 'Our database regularly syncs with source databases. Most pharmaceutical databases are updated monthly or as new information becomes available from government sources.'
    },
    {
      question: 'What databases are integrated?',
      answer: 'We integrate data from: FDA Drugs@FDA, FDA Orange Book, ClinicalTrials.gov, ChEBI, ChEMBL, PubChem, RxNorm, and DailyMed.'
    },
    {
      question: 'How do I search for drug interactions?',
      answer: 'Use the RxNorm tool to search for a drug name, then click on the result to view known drug interactions with severity levels (High, Moderate, Low).'
    },
    {
      question: 'Can I export search results?',
      answer: 'Currently, results are displayed on screen. You can copy and paste information as needed. We may add export functionality in future updates.'
    },
    {
      question: 'Is my search history private?',
      answer: 'Recent searches are stored locally on your device using browser storage and are not sent to any server. You have complete control over this data.'
    },
    {
      question: 'How accurate is the data?',
      answer: 'Our data comes directly from authoritative government sources (FDA, NIH, NCBI). However, we recommend verifying critical information with healthcare providers.'
    },
    {
      question: 'How do I contact support?',
      answer: 'You can reach our support team through the Contact Us page or email us at admin@ijcbr.com.'
    }
  ];

  return (
    <div className="page-container">
      <SEO
        title="FAQ - Pharmaceutical Database"
        description="Find answers to frequently asked questions about Pharmaceutical Database. Learn about our data sources, features, privacy policy, and how to use our platform effectively."
        keywords="FAQ, pharmaceutical database questions, drug database help, how to use, data sources, privacy"
        canonical="/faq"
        structuredData={seoStructuredData}
      />
      <h1 className="page-title">Frequently Asked Questions</h1>
      <p className="page-description">Find answers to common questions about Pharmaceutical Database</p>

      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {faqs.map((faq, index) => (
          <div key={index} style={{ marginBottom: '1rem' }}>
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              style={{
                width: '100%',
                padding: '1rem',
                backgroundColor: openIndex === index ? '#3498db' : '#f8f9fa',
                color: openIndex === index ? 'white' : '#2c3e50',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500',
                textAlign: 'left',
                transition: 'all 0.2s'
              }}
            >
              <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {faq.question}
                <span style={{ fontSize: '1.2rem' }}>
                  {openIndex === index ? '−' : '+'}
                </span>
              </span>
            </button>
            {openIndex === index && (
              <div style={{
                padding: '1rem',
                backgroundColor: '#f0f4f8',
                borderRadius: '0 0 4px 4px',
                color: '#7f8c8d',
                lineHeight: '1.6',
                marginBottom: '0.5rem'
              }}>
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
